import { pdfjs } from 'react-pdf';

export const CDN_PDF_WORKER = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

export function initPdfWorker() {
    pdfjs.GlobalWorkerOptions.workerSrc = CDN_PDF_WORKER;
}
